import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {groupBy} from '../../../helpers/utils';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import dashboard4 from '../locales/dashboard4.json';
import {Label, Select} from '../../../common/components/form';

import "video-react/dist/video-react.css";
import {Player, BigPlayButton, ControlBar, ReplayControl} from 'video-react';

import "react-bootstrap-modal/lib/css/rbm-patch.css";
import Modal from 'react-bootstrap-modal';
import InspectionQtyTrends from './subComponents/InspectionQtyTrends';
import DefectQtyTrends from './subComponents/DefectQtyTrends';
import {IconLink} from '../../../common/components/link';

class DashboardBox4 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalOpen: false,
			modalVideoSrc: '',
			isLoading: true,
			workOrdersList: [],
			partsList: [],
			inspections: {},
			inspectionsLast3days: {},
			inspectionsLast7days: {},
			defects: [],
			partInspections: [],
			partInspectionsLast3days: [],
			partInspectionsLast7days: [],
			workInstructions: [],
			work_order_id: '',
			part_id: '',
		}
	}

	openModal = (e, src) => this.setState({ modalOpen: true, modalVideoSrc: src });
	closeModal = () => this.setState({ modalOpen: false });

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard4);
		this.loadDashboard();
	}

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/4`);

			const workOrdersList = response.data.work_orders.map(item => ({
				value: item.id,
				label: item.old_code ? `${item.code} - ${item.old_code}` : `${item.code}`
			}));

			this.setState({isLoading: false, workOrdersList: workOrdersList});
		} catch (error) {
			notifyError(error.message);
		}
	};

	loadDashboardWorkOrder = async (workOrderId) => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/4/${workOrderId}`);

			const partsList = response.data.work_order.parts.map(item => ({
				value: item.id,
				label: item.number
			}));

			const inspections = response.data.inspections;
			const inspectionsLast3days = response.data.inspections_last_3_days;
			const inspectionsLast7days = response.data.inspections_last_7_days;

			const workInstructions = response.data.work_instructions;

			this.setState({
				partsList: partsList,
				inspections: groupBy(inspections, 'work_order_id'),
				inspectionsLast3days: groupBy(inspectionsLast3days, 'work_order_id'),
				inspectionsLast7days: groupBy(inspectionsLast7days, 'work_order_id'),
				workInstructions: workInstructions,
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	loadDashboardWorkOrderPart = async (partId) => {
		const {notifyError} = this.props;
		try {
			const {work_order_id: workOrderId} = this.state;
			const response = await api.get(`/dashboard/4/${workOrderId}/${partId}`);

			const workOrder = response.data.work_order;
			const defects = workOrder.parts[0].defects;

			const partInspections = response.data.part_inspections;
			const partInspectionsLast3days = response.data.part_inspections_last_3_days;
			const partInspectionsLast7days = response.data.part_inspections_last_7_days;

			this.setState({
				defects: defects,
				partInspections: partInspections,
				partInspectionsLast3days: partInspectionsLast3days,
				partInspectionsLast7days: partInspectionsLast7days
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	workOrderSelected = (selected) => {
		this.setState({work_order_id: selected || ''});
		if( !(selected === null || selected === '') ) {
			this.loadDashboardWorkOrder(selected);
		}
	};

	partSelected = (selected) => {
		this.setState({part_id: selected || ''});
		if( !(selected === null || selected === '') ) {
			this.loadDashboardWorkOrderPart(selected);
		}
	};

	render() {
		const COLORS = ['#F15854', '#DECF3F', '#B276B2', '#B2912F','#F17CB0','#60BD68','#FAA43A','#5DA5DA','#4D4D4D'];

		const {translate, session} = this.props;
		const permissionNames = session.permission_names;
		const {
			workOrdersList, work_order_id : workOrderId,
			partsList, part_id: partId,
			workInstructions, inspectionsLast3days, inspectionsLast7days, inspections,
			defects, partInspectionsLast3days, partInspectionsLast7days, partInspections
		} = this.state;

		let sumTotalInspected = 0;
		let sumTotalDefect = 0;
		let sumTotalRework = 0;
		const barChartDataLast3days = {
			totalInspected: 0,
			totalCertified: 0,
			totalRejected: 0
		};

		const barChartDataLast7days = {
			totalInspected: 0,
			totalCertified: 0,
			totalRejected: 0
		};

		const barChartData = {
			totalInspected: 0,
			totalCertified: 0,
			totalRejected: 0,
			percentageDefect: 0
		};

		let pieChartDataLast3days = {};
		let pieChartDataLast7days = {};
		let pieChartData = {};

		if(workOrderId) {
			if (inspectionsLast3days[workOrderId]) {
				sumTotalInspected = parseInt(inspectionsLast3days[workOrderId][0].sum_total_inspected, 10);
				sumTotalDefect = parseInt(inspectionsLast3days[workOrderId][0].sum_total_defect, 10);
				sumTotalRework = parseInt(inspectionsLast3days[workOrderId][0].sum_total_rework, 10);

				barChartDataLast3days.totalInspected = sumTotalInspected;
				barChartDataLast3days.totalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
				barChartDataLast3days.totalRejected = sumTotalDefect - sumTotalRework;
			}

			if (inspectionsLast7days[workOrderId]) {
				sumTotalInspected = parseInt(inspectionsLast7days[workOrderId][0].sum_total_inspected, 10);
				sumTotalDefect = parseInt(inspectionsLast7days[workOrderId][0].sum_total_defect, 10);
				sumTotalRework = parseInt(inspectionsLast7days[workOrderId][0].sum_total_rework, 10);

				barChartDataLast7days.totalInspected = sumTotalInspected;
				barChartDataLast7days.totalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
				barChartDataLast7days.totalRejected = sumTotalDefect - sumTotalRework;
			}

			if (inspections[workOrderId]) {
				sumTotalInspected = parseInt(inspections[workOrderId][0].sum_total_inspected, 10);
				sumTotalDefect = parseInt(inspections[workOrderId][0].sum_total_defect, 10);
				sumTotalRework = parseInt(inspections[workOrderId][0].sum_total_rework, 10);

				barChartData.totalInspected = sumTotalInspected;
				barChartData.totalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
				barChartData.totalRejected = sumTotalDefect - sumTotalRework;
			}

			if(partId) {
				pieChartDataLast3days = defects.reduce((accumulator, item) => {
					accumulator[item.id] = 0;
					return accumulator
				}, {});

				partInspectionsLast3days.map((inspection) => {
					const defectsJson = inspection.defects_json || {};
					defects.map((defect) => {
						const quantity = defectsJson[defect.id] || 0;
						pieChartDataLast3days[defect.id] += quantity;
						return true;
					});
					return true;
				});

				pieChartDataLast7days = defects.reduce((accumulator, item) => {
					accumulator[item.id] = 0;
					return accumulator
				}, {});

				partInspectionsLast7days.map((inspection) => {
					const defectsJson = inspection.defects_json || {};
					defects.map((defect) => {
						const quantity = defectsJson[defect.id] || 0;
						pieChartDataLast7days[defect.id] += quantity;
						return true;
					});
					return true;
				});

				pieChartData = defects.reduce((accumulator, item) => {
					accumulator[item.id] = 0;
					return accumulator
				}, {});

				partInspections.map((inspection) => {
					const defectsJson = inspection.defects_json || {};
					defects.map((defect) => {
						const quantity = defectsJson[defect.id] || 0;
						pieChartData[defect.id] += quantity;
						return true;
					});
					return true;
				});
			}
		}

		const content = (
			<div className="content-wrapper">
				<section className="content">
					<div className="row">
						<div className="col-md-3">
							<div className="box">
								<div className="box-body with-top-padding">
									<div className="form-group">
										<Label text={translate('dashboard_page_work_order_id')}/>
										<Select list={workOrdersList} value={workOrderId} onChange={this.workOrderSelected}/>
									</div>
								</div>
							</div>

							{
								workOrderId && (
									<div className="box">
										<div className="box-body with-top-padding">
											<div className="form-group">
												<Label text="Part"/>
												<Select list={partsList} value={partId} onChange={this.partSelected}/>
											</div>
										</div>
									</div>
								)
							}

							{
								workOrderId && workInstructions.length > 0 && (
									<div className="box">
										<div className="box-header">
											<h3 className="box-title">Work Instructions</h3>
										</div>
										<div className="box-body">
											<ul style={{paddingLeft: "15px"}}>
												{
													workInstructions.map((item, index) => {
														return (
															<li key={`dashboard_work_instruction_${index}`} style={{marginBottom: "10px"}}>
																{
																	permissionNames && permissionNames.includes('view_work_instruction')
																		? <IconLink type="link" to={`/work-instructions/detail/${item.id}`} text={item.code}/>
																		: item.code
																}
																{
																	item.video && (
																		<button type='button' className="btn btn-xs btn-success" onClick={e => this.openModal(e, item.video_url)}>Play</button>
																	)
																}
																<br/>
																{
																	item.description && "Description: " + item.description
																}
															</li>
														)
													})
												}
											</ul>
										</div>
									</div>
								)
							}
						</div>
						<div className="col-md-9">
							{
								workOrderId && (
									<div className="row">
										<div className="col-md-6">
											<div className="box">
												<div className="box-header">
													<h3 className="box-title">Today (All Parts)</h3>
												</div>
												<div className="box-body">
													<InspectionQtyTrends height={200} data={[
														{name: 'Total Inspected', value: barChartDataLast3days.totalInspected, fill: "#2c7be5"},
														{name: 'Total Certified', value: barChartDataLast3days.totalCertified, fill: "#00a65a"},
														{name: 'Total Rejected', value: barChartDataLast3days.totalRejected, fill: "#dd4b39"}
													]}/>
												</div>
											</div>

											<div className="box">
												<div className="box-header">
													<h3 className="box-title">Past 7 Days</h3>
												</div>
												<div className="box-body">
													<InspectionQtyTrends height={200} data={[
														{name: 'Total Inspected', value: barChartDataLast7days.totalInspected, fill: "#2c7be5"},
														{name: 'Total Certified', value: barChartDataLast7days.totalCertified, fill: "#00a65a"},
														{name: 'Total Rejected', value: barChartDataLast7days.totalRejected, fill: "#dd4b39"}
													]}/>
												</div>
											</div>

											<div className="box">
												<div className="box-header">
													<h3 className="box-title">Since Start</h3>
												</div>
												<div className="box-body">
													<InspectionQtyTrends height={200} data={[
														{name: 'Total Inspected', value: barChartData.totalInspected, fill: "#2c7be5"},
														{name: 'Total Certified', value: barChartData.totalCertified, fill: "#00a65a"},
														{name: 'Total Rejected', value: barChartData.totalRejected, fill: "#dd4b39"}
													]}/>
												</div>
											</div>
										</div>

										<div className="col-md-6">
											{
												partId &&
													<Fragment>
														<div className="box">
															<div className="box-header">
																<h3 className="box-title">Today (All Parts)</h3>
															</div>
															<div className="box-body">
																<DefectQtyTrends height={200} data={defects.map((defect, index) => ({
																	name: defect.name,
																	value: pieChartDataLast3days[defect.id],
																	fill: COLORS[index % COLORS.length]
																})).sort((a, b) => b.value - a.value)
																}/>
															</div>
														</div>

														<div className="box">
															<div className="box-header">
																<h3 className="box-title">Past 7 Days</h3>
															</div>
															<div className="box-body">
																<DefectQtyTrends height={200} data={defects.map((defect, index) => ({
																	name: defect.name,
																	value: pieChartDataLast7days[defect.id],
																	fill: COLORS[index % COLORS.length]
																})).sort((a, b) => b.value - a.value)
																}/>
															</div>
														</div>

														<div className="box">
															<div className="box-header">
																<h3 className="box-title">Since Start</h3>
															</div>
															<div className="box-body">
																<DefectQtyTrends height={200} data={defects.map((defect, index) => ({
																	name: defect.name,
																	value: pieChartData[defect.id],
																	fill: COLORS[index % COLORS.length]
																})).sort((a, b) => b.value - a.value)
																}/>
															</div>
														</div>
													</Fragment>
											}
										</div>
									</div>
								)
							}
						</div>
					</div>
				</section>

				<Modal show={this.state.modalOpen} onHide={this.closeModal}>
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>Video</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{
							this.state.modalOpen && (
								<Player src={this.state.modalVideoSrc} autoPlay={false} loop={true}>
									<BigPlayButton position="center" />
									<ControlBar autoHide={false}>
										<ReplayControl seconds={30} order={2.1} />
									</ControlBar>
								</Player>
							)
						}
					</Modal.Body>
				</Modal>
			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox4);
